module.exports = __webpack_public_path__ + "06ce39ee3e1f0eac10498af3e03794d6.svg";